export class ExamsSubjectsBalls {
  subjectId: number = null;
  subject: any;
  points = 0;
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/edu-info/exams-subjects-balls.ts